export const state = {
  // Store the current user changeovers
  runningChangeover: null,
  isModalRunningChangeoverOpen: true,
};

export const getters = {
  runningChangeover: (state) => state.runningChangeover,
  isModalRunningChangeoverOpen: (state) => state.isModalRunningChangeoverOpen,
};

// mutations
export const mutations = {
  commitRunningChangeovers(state, runningChangeovers) {
    state.runningChangeover = runningChangeovers;
  },
  commitIsModalRunningChangeoverOpen(state, openState) {
    state.isModalRunningChangeoverOpen = openState;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
